__turbopack_context__.v({
  "bannerContainerRoot": "styles-module-scss-module__xoh-WG__bannerContainerRoot",
});
